<div
  data-cy="guided-tour.dialog"
  #dialog
  class="step-container">
  <div class="step">
    <div class="step__header">
      <span
        data-cy="guided-tour-step.step-number"
      >{{
          'guidedTour.stepPagination' | translate:{
        currentStepNumber: step.dialog.stepNumber,
        numberOfSteps: step.dialog.stepCount
      } }}</span>
      @if (!step.dialog.hideExitDemo) {
        <span
          (click)="exitDemo()"
          class="step__header-exit-demo"
        >{{ 'page.planner.guidedTour.action.exitDemo' | translate }}</span>
      }
    </div>

    <div class="step-contents">
      @if (step.dialog.description) {
        <div
          class="step-contents__description"
        >{{ step.dialog.description | translate }}
        </div>
      } @if (step.dialog.nextStepDescription) {
      <div
        class="step-contents__next-step-description"
      >{{ step.dialog.nextStepDescription | translate }}
      </div>
    }

      <div>
        @if (step.dialog.displayNextStepButton) {
          <button
            (click)="onNextClick()"
            class="media-button media-button--secondary step-contents__actions"
            data-cy="guided-tour.dialog-next-button"
          >{{ 'page.planner.guidedTour.action.next' | translate }}
          </button>
        } @if (step.dialog.displayExitCampaignButton) {
        <button
          data-cy="guided-tour.dialog-exit-demo-button"
          (click)="exitDemo()"
          class="media-button media-button--secondary step-contents__actions"
        >{{ 'page.planner.guidedTour.action.exitDemo' | translate }}
        </button>
      }
      </div>
    </div>

  </div>
</div>
